import type { ReactNode } from "react";
import styles from "./labeled-box.module.scss";

export const LabeledBox = ({ label, children }: { label?: string, children: ReactNode }) => {
  return (
    <div className={styles["labeled-box"]}>
      {
        label &&
        <div className={styles["labeled-box__label"]}>
          {label}
        </div>
      }

      <div
        className={styles["labeled-box__content"]}
        data-labeled-box-content
      >
        {children}
      </div>
    </div>
  )
}
